import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Title = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // 경로와 제목 매핑
    const titles = {
      '/': 'MilkyWay Download',
      '/CNdownload': 'MilkyWay 下载',
    };

    // 동적 경로 처리
    if (location.pathname.startsWith('/plm_order')) {
      document.title = '발주현황'; // 동적 경로 기본 제목
    } else {
      document.title = titles[location.pathname] || 'interstellar'; // 기본 제목
    }
  }, [location]);

  return <>{children}</>;
};

export default Title;
